import { SET_SOCIAL_LIMIT_ERROR_DIALOG } from './ActionTypes';

export const setSocialLimitErrorDialog = ({ open, errorType, isGroup = false }) => {
    return {
        type: SET_SOCIAL_LIMIT_ERROR_DIALOG,
        open,
        errorType,
        isGroup
    };
};
